var NoCacheHeadersInterceptorService = /** @class */ (function () {
    function NoCacheHeadersInterceptorService() {
    }
    NoCacheHeadersInterceptorService.prototype.intercept = function (req, next) {
        var authReq = req.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache'
            }
        });
        return next.handle(authReq);
    };
    return NoCacheHeadersInterceptorService;
}());
export { NoCacheHeadersInterceptorService };



// WEBPACK FOOTER //
// ./src/app/no-cache-headers-interceptor.service.ts.pre-build-optimizer.js